import { Typography, Box, Container } from '@mui/material';
import Image from 'next/image';

import { useStyles } from './useStyles';

const SURYA_IMG = 'https://d222i9ppxs2fqe.cloudfront.net/surya_img.png';

interface IBiographyComponent {
  slice: any;
}

const BiographyComponent = ({ slice }: IBiographyComponent) => {
  const { variation, primary } = slice || {};
  const { name, personality, description, person_image } = primary || {};
  const { url, alt } = person_image || {};

  const classes = useStyles();
  const SURYA = 'suryaVaidyanathan';

  return (
    <Box className={classes.mainContainer}>
      <Container maxWidth="xl" disableGutters className={classes.container}>
        <Box className={classes.imgWrapper}>
          {variation === SURYA || url ? (
            <Image
              src={variation === SURYA ? SURYA_IMG : url}
              alt={alt || name}
              objectFit="contain"
              layout="fill"
            />
          ) : null}
        </Box>
        <Box className={classes.rightContainer}>
          <Typography variant="h3" align="left" color="cinnamon.main">
            {variation === SURYA ? 'Surya Vaidyanathan' : name}
          </Typography>
          <Typography variant="body1" align="left" color="cumin.main">
            {variation === SURYA
              ? 'Food Hopper, Pop Culture Nerd'
              : personality}
          </Typography>
          <Typography
            variant="body2"
            align="left"
            color="garamMasala.main"
            maxWidth="840px"
          >
            {variation === SURYA
              ? 'Surya is a Fremont-based designer, illustrator, and street food afficionado. When she isn’t burning her fingers while trying new recipes, she writes about food, culture, and speculative fiction.'
              : description}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default BiographyComponent;
